var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Pane, Row, Col, AccordionSet, PaneFooter, ErrorModal, Button, MessageBanner, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm, FormProvider, } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useOkapiKy } from "@folio/stripes/core";
import { useQuery } from "react-query";
import { navigation } from "../../components/navigation";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { createProductSchema } from "../../utils/validationUtils";
import { useModal } from "../../utils/useModal";
import { FormFooterStart } from "../../components/FormFooterStart";
import { FormFooterEnd } from "../../components/FormFooterEnd";
import { fetchTitleById } from "../../api/titleService";
import { buildProductPayload } from "../../utils/buildProductPayload";
import { ProductRelationsSection } from "../../components/product/ProductRelationsSection";
import { ProductGeneralSection } from "../../components/product/ProductGeneralSection";
import { ProductPrimaryContentTypeMismatchModal } from "../../components/product/ProductPrimaryContentTypeMismatchModal";
import { ProductMeasuresSection } from "../../components/product/ProductMeasuresSection";
import { ProductExtentsSection } from "../../components/product/ProductExtentsSection";
import { ProductDetailsSection } from "../../components/product/ProductDetailsSection";
import { ProductPriceSection } from "../../components/product/ProductPriceSection";
import { useScrollToError } from "../../hooks/useScrollToError";
import { getErrorCode } from "../../utils/getErrorCode";
import { resolveProductCreateErrorMessageId } from "../../utils/productCreateErrors";
var ProductForm = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var initialValues = _a.initialValues, onSubmit = _a.onSubmit, title = _a.title, titleId = _a.titleId, infoMessage = _a.infoMessage, requiredPrimaryContentTypeValue = _a.requiredPrimaryContentTypeValue;
    var formatMessage = useIntl().formatMessage;
    var history = useHistory();
    var ky = useOkapiKy();
    var _u = useModal(), isOpen = _u.isOpen, message = _u.message, openModal = _u.openModal, closeModal = _u.closeModal;
    var _v = useState(!!initialValues.price), showPrice = _v[0], setShowPrice = _v[1];
    var _w = useState(false), contentTypeMismatchOpen = _w[0], setContentTypeMismatchOpen = _w[1];
    var _x = useState({
        general: true,
        measures: true,
        extents: true,
        details: true,
        price: true,
        relations: true,
    }), accordionStatus = _x[0], setAccordionStatus = _x[1];
    var _y = useState(true), expandAll = _y[0], setExpandAll = _y[1];
    var toggleAccordion = function (section) {
        setAccordionStatus(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[section] = !prev[section], _a)));
        });
    };
    var toggleExpandCollapseAll = function () {
        setAccordionStatus({
            general: !expandAll,
            measures: !expandAll,
            extents: !expandAll,
            details: !expandAll,
            price: !expandAll,
            relations: !expandAll,
        });
        setExpandAll(!expandAll);
    };
    var titleData = useQuery(["title", titleId], function () { return fetchTitleById(ky, titleId); }, {
        enabled: !!titleId,
    }).data;
    var methods = useForm({
        resolver: zodResolver(createProductSchema(formatMessage)),
        defaultValues: initialValues,
        mode: "onSubmit",
    });
    var handleSubmit = methods.handleSubmit, reset = methods.reset, errors = methods.formState.errors;
    useScrollToError(errors);
    useEffect(function () {
        reset(initialValues);
    }, [initialValues, reset]);
    var handleFormSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var cleanedData, error_1, errorMessage, _a, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    // All products of one title must share the same primary content type. The
                    // field is pre-filled but editable; if the user picked a different type, show
                    // the info dialog and stop instead of saving.
                    if (requiredPrimaryContentTypeValue &&
                        ((_c = data.primaryContentType) === null || _c === void 0 ? void 0 : _c.value) &&
                        data.primaryContentType.value !== requiredPrimaryContentTypeValue) {
                        setContentTypeMismatchOpen(true);
                        return [2 /*return*/];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 7]);
                    cleanedData = buildProductPayload(data, {
                        title: titleData || data.title,
                        showPrice: showPrice,
                    });
                    return [4 /*yield*/, onSubmit(cleanedData)];
                case 2:
                    _d.sent();
                    return [3 /*break*/, 7];
                case 3:
                    error_1 = _d.sent();
                    if (!initialValues.id) return [3 /*break*/, 4];
                    _a = "ui-br-agency.product.error.update";
                    return [3 /*break*/, 6];
                case 4:
                    _b = resolveProductCreateErrorMessageId;
                    return [4 /*yield*/, getErrorCode(error_1)];
                case 5:
                    _a = _b.apply(void 0, [_d.sent()]);
                    _d.label = 6;
                case 6:
                    errorMessage = _a;
                    openModal(formatMessage({ id: errorMessage }));
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var publisherName = ((_d = (_c = (_b = titleData === null || titleData === void 0 ? void 0 : titleData.titlePublishers) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.publisher) === null || _d === void 0 ? void 0 : _d.name) || "-";
    var firstContributor = ((_f = (_e = titleData === null || titleData === void 0 ? void 0 : titleData.titleContributions) === null || _e === void 0 ? void 0 : _e.find(function (c) { return c.person; })) === null || _f === void 0 ? void 0 : _f.firstName) &&
        ((_h = (_g = titleData === null || titleData === void 0 ? void 0 : titleData.titleContributions) === null || _g === void 0 ? void 0 : _g.find(function (c) { return c.person; })) === null || _h === void 0 ? void 0 : _h.lastName)
        ? "".concat((_k = (_j = titleData === null || titleData === void 0 ? void 0 : titleData.titleContributions) === null || _j === void 0 ? void 0 : _j.find(function (c) { return c.person; })) === null || _k === void 0 ? void 0 : _k.firstName, " ").concat((_m = (_l = titleData === null || titleData === void 0 ? void 0 : titleData.titleContributions) === null || _l === void 0 ? void 0 : _l.find(function (c) { return c.person; })) === null || _m === void 0 ? void 0 : _m.lastName)
        : ((_p = (_o = titleData === null || titleData === void 0 ? void 0 : titleData.titleContributions) === null || _o === void 0 ? void 0 : _o.find(function (c) { return c.person; })) === null || _p === void 0 ? void 0 : _p.name) || "-";
    var titleName = ((_r = (_q = titleData === null || titleData === void 0 ? void 0 : titleData.names) === null || _q === void 0 ? void 0 : _q.find(function (n) { var _a; return ((_a = n.type) === null || _a === void 0 ? void 0 : _a.value) === "01"; })) === null || _r === void 0 ? void 0 : _r.name) ||
        ((_t = (_s = titleData === null || titleData === void 0 ? void 0 : titleData.names) === null || _s === void 0 ? void 0 : _s[0]) === null || _t === void 0 ? void 0 : _t.name) ||
        "-";
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { defaultWidth: "fill", paneTitle: title, footer: React.createElement(PaneFooter, { renderStart: React.createElement(FormFooterStart, { handleSubmit: handleSubmit, onSubmit: handleFormSubmit, buttonMessageId: "ui-br-agency.button.save" }), renderEnd: React.createElement(FormFooterEnd, { onCancel: function () {
                        if (titleId) {
                            history.push("/bragency/titles?detail=".concat(titleId));
                        }
                        else if (navigation.products) {
                            history.push(navigation.products.path);
                        }
                    }, buttonMessageId: "ui-br-agency.button.cancel" }) }) },
            React.createElement(ErrorModal, { open: isOpen, label: formatMessage({ id: "ui-br-agency.modal.label.error" }), content: message, onClose: closeModal }),
            infoMessage && (React.createElement(MessageBanner, { type: "warning" }, infoMessage)),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, style: { display: "flex", justifyContent: "flex-end" } },
                    React.createElement(Button, { onClick: toggleExpandCollapseAll, buttonStyle: "default" }, expandAll
                        ? formatMessage({ id: "ui-br-agency.button.collapse" })
                        : formatMessage({ id: "ui-br-agency.button.expand" })))),
            React.createElement(FormProvider, __assign({}, methods),
                React.createElement("form", { noValidate: true, onSubmit: handleSubmit(handleFormSubmit) },
                    titleId && titleData && (React.createElement("div", { style: {
                            marginBottom: "20px",
                            padding: "10px",
                            backgroundColor: "#f5f5f5",
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement("strong", null,
                                    React.createElement(FormattedMessage, { id: "ui-br-agency.product.title.publisher.label" }),
                                    ":"),
                                " ",
                                publisherName)),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement("strong", null,
                                    React.createElement(FormattedMessage, { id: "ui-br-agency.product.title.firstContributor.label" }),
                                    ":"),
                                " ",
                                firstContributor)),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement("strong", null,
                                    React.createElement(FormattedMessage, { id: "ui-br-agency.product.title.title.label" }),
                                    ":"),
                                " ",
                                titleName)))),
                    React.createElement(AccordionSet, null,
                        React.createElement(ProductGeneralSection, { open: accordionStatus.general, onToggle: function () { return toggleAccordion("general"); } }),
                        React.createElement(ProductMeasuresSection, { open: accordionStatus.measures, onToggle: function () { return toggleAccordion("measures"); } }),
                        React.createElement(ProductExtentsSection, { open: accordionStatus.extents, onToggle: function () { return toggleAccordion("extents"); } }),
                        React.createElement(ProductDetailsSection, { open: accordionStatus.details, onToggle: function () { return toggleAccordion("details"); } }),
                        React.createElement(ProductPriceSection, { showPrice: showPrice, onShowPriceChange: setShowPrice, open: accordionStatus.price, onToggle: function () { return toggleAccordion("price"); } }),
                        React.createElement(ProductRelationsSection, { open: accordionStatus.relations, onToggle: function () { return toggleAccordion("relations"); } })))),
            React.createElement(ProductPrimaryContentTypeMismatchModal, { open: contentTypeMismatchOpen, onClose: function () { return setContentTypeMismatchOpen(false); } }))));
};
export default ProductForm;
